import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const popoverStyle = css`
  border-radius: ${theme.borderRadius.small};
  min-width: 300px;
  padding: 0;
`;

export const applyButtonStyle = css`
  padding: ${theme.spacing(2, 1)};
  margin: ${theme.spacing(1, 2, 2, 2)};
  width: -webkit-fill-available;
`;
